import { render, staticRenderFns } from "./editDialogAdministration.vue?vue&type=template&id=407b1cd2"
import script from "./editDialogAdministration.vue?vue&type=script&lang=ts"
export * from "./editDialogAdministration.vue?vue&type=script&lang=ts"
import style0 from "./editDialogAdministration.vue?vue&type=style&index=0&id=407b1cd2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports